import {
  RouteRef,
  SubRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  recordings = 'recordings',
  recording = 'recordings-recording',
  explorer = 'recordings-explorer',
  settings = 'recordings-settings',
  targetingPolicy = 'recordings-targeting-policy',
}

export const rootRouteRef = createRouteRef({
  id: RoutesIds.recordings,
});

export const recordingRouteRef = createSubRouteRef({
  id: RoutesIds.recording,
  parent: rootRouteRef,
  path: '/:id',
});

export const explorerRouteRef = createSubRouteRef({
  id: RoutesIds.explorer,
  parent: rootRouteRef,
  path: '/explorer',
});

export const settingsRouteRef = createSubRouteRef({
  id: RoutesIds.settings,
  parent: rootRouteRef,
  path: '/settings',
});

export const targetingPolicyRouteRef = createSubRouteRef({
  id: RoutesIds.targetingPolicy,
  parent: rootRouteRef,
  path: '/settings/:policyId',
});

export const Routes = {
  [RoutesIds.recordings]: rootRouteRef,
  [RoutesIds.recording]: recordingRouteRef,
  [RoutesIds.explorer]: explorerRouteRef,
  [RoutesIds.settings]: settingsRouteRef,
  [RoutesIds.targetingPolicy]: targetingPolicyRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;
